export default __webpack_public_path__ + "static/media/factor_left_bg.deff5c05.png";